<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      max-width="600px"
      transition="dialog-transition">
      <v-card class="white" v-if="notificationSchedule.id">
        <v-toolbar class="k-orange-linear white--text py-1" flat>
          <v-toolbar-title>
            <v-layout row wrap>
              <v-flex xs12 class="f1-2em">
                {{ notificationSchedule.name || notificationSchedule.first_name }}
              </v-flex>
              <v-flex xs12 class="f0-8em">
                {{ notificationSchedule.account || 'Prueba' }}
              </v-flex>
            </v-layout>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-icon class="white--text mr-3">
              {{showIconChannel(notificationSchedule.status_id)}} 
            </v-icon>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 class="italic k-grey-text mx-2 my-3 justify-center">
              <div
                v-if="notificationSchedule.channel_id === 2 
                || notificationSchedule.channel_id === 1
                || notificationSchedule.channel_id === 7"
                v-html="notificationSchedule.text">
              </div>
              <div
                class="headline text-xs-center"
                v-else-if="(notificationSchedule.channel_id === 3 
                  || notificationSchedule.channel_id === 4 
                  || notificationSchedule.channel_id === 5
                  || notificationSchedule.channel_id === 6
                  ) && !notificationSchedule.url_record">
                No hay grabación
              </div>
              <av-line
                v-if="notificationSchedule.url_record && canSeeAudio"
                :line-width="1"
                :canv-width="552"
                :canv-heigh="80"
                line-color="#ff7c64"
                :canv-top="true"
                :cors-anonym="true"
                class="customized-audio"
                :audio-src="notificationSchedule.url_record">
              </av-line>
            </v-flex>
          </v-layout>
          <v-divider class="mt-2 mb-1"></v-divider>
          <v-layout row wrap>
            <v-flex xs12 class="mx-2 my-3" v-if="notificationSchedule.channel_id === 3 && !notificationSchedule.url_record && canSeeAudio">
              <audio-text :notification-schedule="notificationSchedule"></audio-text>
            </v-flex>
            <v-flex xs12 class="mx-2">
              
                <br/>
                <span v-if="notificationSchedule.descrip !== null" class="grey--text ml-4">
                  <strong>Descripción: </strong>{{ notificationSchedule.descrip }}
                </span>
                <br/>

              <v-stepper v-model="activeStep" vertical class="elevation-0">
                <template v-for="(item, i) in steps" v-if="item.date">
                  <v-stepper-step :step="`${i + 1}`" editable>
                    {{ item.text }} 
                    <small>
                      {{ item.date }}
                    </small>
                  </v-stepper-step>
                </template>
              </v-stepper>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap>
            <template v-if="actionButtons && notificationSchedule.status_id !== 11">
              <v-flex xs8 class="text-xs-left">
                <v-btn v-if="notificationSchedule.status_id !== 29 && notificationSchedule.status_id !== 24 && notificationSchedule.status_id !== 39" class="k-orange-linear-text" flat @click="openRightDrawer()">
                  Cambiar estado
                </v-btn>
                <v-btn v-else-if="notificationSchedule.status_id !== 29 && (notificationSchedule.status_id === 24 || notificationSchedule.status_id === 39)" class="k-orange-linear-text" flat @click="reschedule()">
                  Reprogramar
                </v-btn>
                <v-btn v-if="!notificationSchedule.reviewed_at && notificationSchedule.status_id !== 29 && notificationSchedule.status_id !== 24 && notificationSchedule.status_id !== 39" class="k-orange-linear-text" flat @click="markReviewed()">
                  Revisado
                </v-btn>
              </v-flex>
            </template>
            <v-flex :class="{'text-xs-right': true, 'xs4': actionButtons && notificationSchedule.status_id !== 11, 'xs12': !actionButtons }">
              <v-btn color="black" flat @click="dialog = !dialog">CERRAR</v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <rightDrawer
      :url="`/notification_schedules/${activeNotificationSchedule}`"
      content="notificationScheduleForm"
      :edit="true">
      <div class="f1-2em k-orange-linear-text" slot="title">
        Cambiar estado
      </div>
    </rightDrawer>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import EventBus from '@/event-bus';
import notificationScheduleForm from '@/components/global/sidebar_forms/NotificationScheduleForm';
import rightDrawer from '@/components/global/RightDrawer';
import ChannelsMixins from '@/mixins/channels';
import permissionsMixin from '@/mixins/permissions';
import AudioText from '@/components/global/AudioText';

Vue.component('notificationScheduleForm', notificationScheduleForm);

export default {
  mixins: [ChannelsMixins, permissionsMixin],
  components: {
    AudioText,
    rightDrawer,
  },
  props: {
    actionButtons: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    EventBus.$on('showNotificationDetail', (id) => {
      this.activeNotificationSchedule = id;
      this.getNotificationSchedule(id);
    });
    EventBus.$on('rightDrawerSaved', () => {
      this.dialog = false;
    });
  },
  destroyed() {
    EventBus.$off('showNotificationDetail');
    EventBus.$off('rightDrawerSaved');
  },
  data() {
    return {
      dialog: false,
      notificationSchedule: {},
      activeStep: 1,
      activeNotificationSchedule: 0,
      steps: [
        {
          field: 'processed_at',
          text: 'Gestión procesada',
          date: null,
        },
        {
          field: 'sent_carrier_at',
          text: 'Enviado al operador',
          date: null,
        },
        {
          field: 'sent_at',
          text: 'Enviado al cliente',
          date: null,
        },
        {
          field: 'delivered_at',
          text: 'Entregado al cliente',
          date: null,
        },
        {
          field: 'read_at',
          text: 'Leido',
          date: null,
        },
        /* {
          field: 'next_contact_at',
          text: 'Proximo contacto',
          date: null,
        }, */
        {
          field: 'click_at',
          text: '',
          date: null,
        },
        {
          field: 'payment_promise_at',
          text: 'Se comprometió',
          date: null,
        },
      ],
    };
  },
  computed: {
    canSeeAudio() {
      return this.checkPermissions([
        'see_recordings',
      ]);
    },
  },
  methods: {
    getNotificationSchedule(id) {
      this.axios.get(`notification_schedules/${id}`).then((response) => {
        this.notificationSchedule = response.data;
        this.steps.forEach((item, i) => {
          if (this.notificationSchedule[item.field]) {
            this.steps[i].date = moment.utc(this.notificationSchedule[item.field]).local().format('DD/MM/YYYY hh:mm A');
            if (item.field === 'click_at') {
              this.steps[i].text = 'Click en un link';
            }
          } else {
            this.steps[i].date = null;
          }
        });
        this.getTemplateText(id);
      }).catch(() => {
        this.axios.get(`notification_schedules_hst/${id}`).then((response) => {
          this.notificationSchedule = response.data;
          this.steps.forEach((item, i) => {
            if (this.notificationSchedule[item.field]) {
              this.steps[i].date = moment.utc(this.notificationSchedule[item.field]).local().format('DD/MM/YYYY hh:mm A');
              if (item.field === 'click_at') {
                this.steps[i].text = 'Click en un link';
              }
            } else {
              this.steps[i].date = null;
            }
          });
          this.getTemplateText(id);
        }).catch(() => {
          EventBus.$emit('modal', 'Hubo un error al mostrar el detalle');
        });
      });
      
    },
    openRightDrawer() {
      EventBus.$emit('openRightDrawer');
    },
    reschedule() {
      this.axios.patch(`/notification_schedules/${this.notificationSchedule.id}`, {
        status: 29,
      }).then(() => {
        EventBus.$emit('closeRightDrawer');
        EventBus.$emit('rightDrawerSaved');
        this.dialog = false;
      }).catch(() => {});
    },
    markReviewed() {
      const reviewedAt = moment().format('YYYY-MM-DD HH:mm:ss');
      this.axios.patch(`/notification_schedules/${this.notificationSchedule.id}`, {
        reviewed_at: reviewedAt,
      }).then(() => {
        EventBus.$emit('update');
        this.dialog = false;
      });
    },
    getTemplateText(id) {
      if (
        (!this.notificationSchedule.text) 
        && [1, 2, 7].includes(this.notificationSchedule.channel_id)
      ) {
        const url = `/templates/text/${this.notificationSchedule.channel_id}/${id}`;
        this.axios.get(url)
          .then((response) => {
            this.notificationSchedule.text = response.data;
            this.dialog = true;
          })
      } else {
        this.dialog = true;
      }
    },
  },
  watch: {
    dialog(newVal) {
      if (!newVal) {
        this.notificationSchedule = {}
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/notification_schedule/Detail.vue